import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ProfileSection, { type ProfileSectionType } from './ProfileSection';

interface DangerZone {
  title: string;
  description?: string;
  actions: React.ReactNode;
}

interface ProfileLayoutProps {
  sections: ProfileSectionType[];
  dangerZone?: DangerZone;
  editing: boolean;
  saving?: boolean;
  onEdit: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  /** Indexes of sections that should show edit/save/cancel buttons (default: [0] — first section only) */
  editableSections?: number[];
}

const ProfileLayout: React.FC<ProfileLayoutProps> = ({
  sections,
  dangerZone,
  editing,
  saving,
  onEdit,
  onSave,
  onCancel,
  editableSections = [0],
}) => {
  return (
    <Box>
      {sections.map((section, idx) => {
        const isEditable = editableSections.includes(idx);
        return (
          <ProfileSection
            key={idx}
            section={section}
            editing={isEditable ? editing : false}
            saving={saving}
            onEdit={isEditable ? onEdit : undefined}
            onSave={isEditable ? onSave : undefined}
            onCancel={isEditable ? onCancel : undefined}
            hideActions={!isEditable}
          />
        );
      })}

      {dangerZone && (
        <Paper
          sx={{
            p: 3,
            borderRadius: '12px',
            borderLeft: '4px solid',
            borderLeftColor: 'error.main',
            backgroundColor: 'error.50',
            boxShadow: '0px 4px 12px rgba(0,0,0,0.08), 0px 2px 4px rgba(0,0,0,0.04)',
          }}
        >
          <Typography variant="h3" color="error" sx={{ fontSize: 20, fontWeight: 600, mb: 1 }}>
            {dangerZone.title}
          </Typography>
          {dangerZone.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {dangerZone.description}
            </Typography>
          )}
          {dangerZone.actions}
        </Paper>
      )}
    </Box>
  );
};

export default ProfileLayout;
